var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    transform: "matrix(1.375 0 0 1.40655 -6 -7.724)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.22,
    d: "M8 12H24V13.489H8z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.81,
    d: "M8 13.755H24V19H8z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.984,
    d: "M24 18.808a8 6.779 0 01-4 5.87 8 6.779 0 01-8 0 8 6.779 0 01-4-5.87"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.955,
    d: "M14 10H18V11.822H14z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.104,
    d: "M13 8.782H19V10H13z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.787,
    d: "M13 8H19V8.62H13z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHicIcon);
export default __webpack_public_path__ + "static/media/hic-icon.48bce4ce0ff732f265ac390881df807e.svg";
export { ForwardRef as ReactComponent };